import { api } from "./client.js";

export interface City {
  id: string;
  name: string;
  country: string;
  country_code: string;
  timezone: string;
  latitude: number;
  longitude: number;
}

export const citiesApi = {
  search: (q: string) => api.get<City[]>(`/api/cities?q=${encodeURIComponent(q)}`),
};
